<script setup lang="ts">
import type { FieldProps } from "../ui/auto-form";

defineProps<FieldProps>();
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs" class="flex items-start justify-between rounded-lg border p-3 gap-2">
      <div class="space-y-0.5">
        <AutoFormLabel v-if="!config?.hideLabel" :required="required">
          <template v-if="config?.label === 'privacy_policy'">
            Ho preso visione dell’<NuxtLink class="link" href="/privacy">informativa privacy</NuxtLink> e accetto la <NuxtLink class="link" href="/note-legali">user policy</NuxtLink>
          </template>
          <template v-else-if="config?.label === 'marketing'">
            Do il mio consenso libero e informato a ricevere email promozionali. Consulta l'<NuxtLink class="link" href="/privacy">informativa privacy</NuxtLink> completa.
          </template>
          <template v-else>{{ config?.label }}</template>
        </AutoFormLabel>
        <FormDescription v-if="config?.description">
          {{ config.description }}
        </FormDescription>
        <FormMessage />
      </div>
      <FormControl>
        <Switch class="!my-0" v-bind="slotProps" :value="slotProps.value ? 'on' : 'off'" :checked="slotProps.value" @update:checked="(v) => slotProps.setValue(v)" />
      </FormControl>
    </FormItem>
  </FormField>
</template>
